import { Link } from 'react-router-dom';

export default function WhyTheDogsFeature() {
  return (
    <section className="py-16 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4">
        <Link 
          to="/why-the-dogs"
          className="block group"
        >
          <div className="bg-white border border-stone-200 rounded-lg p-8 hover:border-stone-300 transition-colors">
            <div className="flex items-start gap-4">
              <div className="text-4xl flex-shrink-0 opacity-60 group-hover:opacity-80 transition-opacity">
                🐾
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-medium text-stone-900 mb-2 group-hover:text-stone-700 transition-colors">
                  Why the Dogs
                </h3>
                <p className="text-stone-600 text-sm leading-relaxed mb-3">
                  The real reason behind the rescue commitment — not marketing copy, just the honest version.
                </p>
                <span className="text-xs text-stone-500 group-hover:text-stone-700 transition-colors">
                  Read the honest version →
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}